import { render, staticRenderFns } from "./WebsiteBlock.vue?vue&type=template&id=4fb41ed7"
import script from "./WebsiteBlock.vue?vue&type=script&lang=js"
export * from "./WebsiteBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports